import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICommitmentTotalDTO } from '@modules/potential-save-modal/commitment-list/commitment.model';

@Component({
	selector: 'app-commitment-total-row, [app-commitment-total-row]',
	templateUrl: './commitment-total-row.component.html',
	styleUrls: ['./commitment-total-row.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommitmentTotalRowComponent {
	@Input() public commitmentTotal!: ICommitmentTotalDTO;
}
